import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getFirestore, collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Table, Button, Spinner, Modal } from 'react-bootstrap';
import { FaFileImage } from 'react-icons/fa';

const Admin = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const db = getFirestore();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usersList, setUsersList] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  // Estados y handler para modal de detalles de usuario
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const handleApproveUser = async (uid) => {
    await updateDoc(doc(db, 'users', uid), { verificationStatus: 'aprobado' });
    setUsersList(us => us.map(u => u.uid === uid ? { ...u, verificationStatus: 'aprobado' } : u));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return navigate('/login');
      // Optionally fetch userInfo to check isAdmin
      const paymentsSnapshot = await getDocs(collection(db, 'payments'));
      const all = paymentsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setPayments(all);

      // Fetch users for role management
      const usersSnapshot = await getDocs(collection(db, 'users'));
      const users = usersSnapshot.docs.map(d => ({ uid: d.id, ...d.data() }));
      setUsersList(users);
      setLoadingUsers(false);
      setLoading(false);
    };
    fetchData();
  }, [user, navigate, db]);

  const updateStatus = async (id, status) => {
    await updateDoc(doc(db, 'payments', id), { status });
    setPayments(ps => ps.map(p => p.id === id ? { ...p, status } : p));
  };

  const updateUserRole = async (uid, newRole) => {
    await updateDoc(doc(db, 'users', uid), { role: newRole });
    setUsersList(us => us.map(u => u.uid === uid ? { ...u, role: newRole } : u));
  };

  // Ordenar todos los pagos por estado y fecha, sin agrupar
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 10;
  const statusOrder = { 'En revisión': 0, 'Validado': 1, 'Rechazado': 2 };
  const sortedPayments = payments
    .slice()
    .sort((a, b) => {
      if (statusOrder[a.status] !== statusOrder[b.status]) {
        return statusOrder[a.status] - statusOrder[b.status];
      }
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  const totalPages = Math.ceil(sortedPayments.length / rowsPerPage);
  const displayedPayments = sortedPayments.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );

  return (
    <>
      <Header />
        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
          
      <section className="hero-section" id="hero-profile">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-right">
              <h1>Panel de Administración</h1>
              <p className="mb-4">
                Aquí puedes ver y editar tu información personal y las operaciones realizadas.
              </p>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <img src="/assets/img/profile.png" alt="Perfil" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section className="section">
          <div className="container">
          <h3 className="mt-5">Gestión de Pagos</h3>
            {/* Tabla única con todos los pagos */}
            <div className="table-responsive my-3">
              <Table responsive striped hover bordered size="sm" className="align-middle text-center">
              <thead className="table-dark">
                <tr>
                  <th>Usuario</th>
                  <th>Fecha</th>
                  <th>Enviado</th>
                  <th>Recibido</th>
                  <th>Remitente</th>
                  <th>Receptor</th>
                  <th>Comprobante</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedPayments.map(p => {
                  const userInfo = usersList.find(u => u.uid === p.userId) || {};
                  const rowClass =
                    p.status === 'En revisión' ? 'table-warning' :
                    p.status === 'Rechazado'     ? 'table-danger'  :
                    p.status === 'Validado'      ? 'table-success' : '';
                  return (
                    <tr key={p.id} className={rowClass}>
                      <td>{userInfo.firstName || userInfo.lastName
                          ? `${userInfo.firstName} ${userInfo.lastName} — ${userInfo.email}`
                          : userInfo.email || p.userId}
                      </td>
                      <td>{new Date(p.createdAt).toLocaleDateString()}</td>
                      <td>{p.sendAmount} {p.origen}</td>
                      <td>{p.receiveAmount} {p.destino}</td>
                      <td>
                        <div>{p.sender.fullName || `${p.sender.firstName} ${p.sender.lastName}`}</div>
                        {p.sender.email && <div>Email: {p.sender.email}</div>}
                        {p.sender.accountNumber && <div>Cuenta: {p.sender.accountNumber}</div>}
                        {p.sender.mobile && <div>Tel: {p.sender.mobile}</div>}
                        {p.sender.id && <div>ID: {p.sender.id}</div>}
                      </td>
                      <td>
                        <div>{`${p.receiver.firstName} ${p.receiver.lastName}`}</div>
                        {p.receiver.email && <div>Email: {p.receiver.email}</div>}
                        {p.receiver.accountNumber && <div>Cuenta: {p.receiver.accountNumber}</div>}
                        {p.receiver.mobile && <div>Tel: {p.receiver.mobile}</div>}
                        {p.receiver.id && <div>ID: {p.receiver.id}</div>}
                        {p.receiver.bank && <div>Banco: {p.receiver.bank}</div>}
                      </td>
                      <td>
                        {p.paymentReceipt ? (
                          <FaFileImage
                            style={{ cursor: 'pointer' }}
                            size={24}
                            onClick={() => {
                              setSelectedReceipt(p.paymentReceipt);
                              setShowReceiptModal(true);
                            }}
                          />
                        ) : ''}
                      </td>
                      <td>
                        <Button size="sm" variant="success" onClick={() => updateStatus(p.id, 'Validado')}>Validar</Button>{' '}
                        <Button size="sm" variant="danger" onClick={() => updateStatus(p.id, 'Rechazado')}>Rechazar</Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              </Table>
            </div>
            <div id="pagControls" className="d-flex justify-content-between">
              <Button size="sm"
                disabled={currentPage === 0}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Anterior
              </Button>
              <span>Página {currentPage + 1} de {totalPages}</span>
              <Button size="sm"
                disabled={currentPage === totalPages - 1}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Siguiente
              </Button>
            </div>
            {/* User Roles Management */}
            <h3 className="mt-5">Gestión de Roles de Usuarios</h3>
            {loadingUsers ? <Spinner animation="border" /> : (
              <div className="table-responsive my-3">
                <Table responsive striped hover bordered size="sm" className="align-middle text-center">
                <thead className="table-dark">
                  <tr>
                    <th>Usuario</th>
                    <th>Rol</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {usersList.map(u => (
                    <tr key={u.uid} className={
                      u.verificationStatus === 'pendiente' ? 'table-warning' :
                      u.verificationStatus === 'aprobado'  ? 'table-success' : ''
                    }>
                      <td>{(u.displayName || u.name)
                        ? `${u.displayName || u.name} — ${u.email}`
                        : u.email}
                      </td>
                      <td>{u.role || 'cliente'}</td>
                      <td>
                        {/* Cambio de rol */}
                        <Button size="sm" variant={u.role==='cliente'?'secondary':'outline-secondary'} onClick={() => updateUserRole(u.uid, 'cliente')}>Cliente</Button>{' '}
                        <Button size="sm" variant={u.role==='admin'?'secondary':'outline-secondary'} onClick={() => updateUserRole(u.uid, 'admin')}>Admin</Button>{' '}
                        <Button size="sm" variant={u.role==='superadmin'?'secondary':'outline-secondary'} onClick={() => updateUserRole(u.uid, 'superadmin')}>SuperAdmin</Button>{' '}
                        {/* Ver detalles */}
                        <Button size="sm" variant="info" onClick={() => { setSelectedUser(u); setShowUserModal(true); }}>Detalles</Button>{' '}
                        {/* Aprobar usuario */}
                        {u.verificationStatus==='pendiente' && (
                          <Button size="sm" variant="success" onClick={() => handleApproveUser(u.uid)}>Aprobar</Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                </Table>
              </div>
            )}
                      </div>
                    </section>
                  </main>
          </>
        )}
      <Footer />
      <Modal show={showReceiptModal} onHide={() => setShowReceiptModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Comprobante de Pago</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img src={selectedReceipt} alt="Comprobante" className="img-fluid" />
        </Modal.Body>
      </Modal>
      {/* Modal para mostrar detalles de usuario */}
      <Modal show={showUserModal} onHide={() => setShowUserModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Detalles de Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedUser && (
            <div>
              <p><strong>Nombre:</strong> {selectedUser.firstName} {selectedUser.lastName}</p>
              <p><strong>Teléfono:</strong> {selectedUser.phone}</p>
              <p><strong>Email:</strong> {selectedUser.email}</p>
              <p><strong>Cédula:</strong> {selectedUser.idNumber}</p>
              <p><strong>Dirección:</strong> {selectedUser.address}</p>
              <p><strong>País:</strong> {selectedUser.country}</p>
              <p><strong>¿Cómo nos conoció?</strong> {selectedUser.howDidYouKnow}</p>
              <p><strong>Estado de Verificación:</strong> {selectedUser.verificationStatus}</p>
              {selectedUser.documentPhoto && <img src={selectedUser.documentPhoto} alt="Documento" className="img-fluid mb-2" />}
              {selectedUser.selfie && <img src={selectedUser.selfie} alt="Selfie" className="img-fluid" />}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUserModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Admin;
